import React from 'react';
import IcoMoon from 'react-icomoon';

const iconSet = require('./icons.json');

const ArkhamIcon = ({ ...props }) => {
  return <IcoMoon iconSet={iconSet} {...props} />;
};

export default ArkhamIcon;